export enum ActionButtonText {
    ADD = 'Add',
    NEXT = 'Next',
}

export const disabledDatasetTooltipDescription =
    'Each message supports only one dataset. To modify or replace it, all existing instances must be deleted.';
